<template>
  <LinkCard :image="thumbnail" :title="$path('name', value)" :badges="badges" :to="$attrs.to" v-bind="$attrs" />
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

export default {
  props: {
    value: Object,
  },
  computed: {
    thumbnail() {
      return this.$path('image.url', this.value)
    },
    badges() {
      if (this.value.isEntry) return [{ theme: 'primary', value: this.$t('unitSelectorIsEntry') }]
      return []
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
